import { CourseMaterial, useProgramDetails } from "./coursesLoader";
import styles from "./MaterialTopBanner.module.scss";
import { FormattedMessage } from "react-intl";
import useOrderInfo from "./useOrderInfo";
import useVirtualStore from "routes/home/common/virtual-store/useVirtualStore";
import useOptedIn from "./useOptedIn";

export default function MaterialTopBanner({
  material,
}: {
  material: CourseMaterial;
}) {
  const { shippingStatus, returnStatus, isCampusAddress } =
    useOrderInfo(material);
  const { isVirtualStore } = useVirtualStore();
  const isOptedIn = useOptedIn(material);
  const { scope } = useProgramDetails();

  if (!isVirtualStore || isOptedIn || scope !== "ea_only") {
    return null;
  }

  const isItemShipped =
    shippingStatus === "Shipped" ||
    shippingStatus === "Picked Up" ||
    shippingStatus === "Delivered";

  const needsReturn = returnStatus === "Needs to be Returned" && isItemShipped;
  if (!needsReturn) {
    return null;
  }

  return (
    <div className={styles.container}>
      {isCampusAddress ? (
        <FormattedMessage
          defaultMessage="This item has been picked up and you opted out. You need to return your item."
          tagName="span"
        />
      ) : (
        <FormattedMessage
          defaultMessage="This item has shipped and you opted out. You need to return your item."
          tagName="span"
        />
      )}
    </div>
  );
}
